import { inject, Injectable } from '@angular/core';
import { HttpMainService } from '../http-main.service';
import { LeverageModel, ListModel } from '@itb-monorepo/models';
import { Observable } from 'rxjs';

@Injectable()
export class LeverageService {
  baseUrl = '/trade/';
 private _HttpMainService = inject(HttpMainService);


  getLeverages(groupCode: string): Observable<ListModel<LeverageModel>> {
    const qParams = {
      sort: `asc(no)`,
    };
    return this._HttpMainService.get(
      this.baseUrl + `v1/groups/${groupCode}/leverages`,
      qParams
    );
  }
}
